const PeriodEntity = (client) => ({
  update: async (id, data) => await client.put(`/api/periods/${id}`, data),
})

export default PeriodEntity
